import { useAuth as libUseAuth } from "@marekl/adminer";
import type { User } from "./queries";

/** App-typed wrapper around `useAuth()` that returns the faktio User. */
export function useAuth() {
  return libUseAuth<User>();
}

/**
 * True for system administrators (role "admin"), who manage users. Per-company
 * roles (owner, accountant, …) arrive with company membership in Phase 2.
 */
export function useIsAdmin(): boolean {
  const { user } = useAuth();
  return user?.role === "admin";
}
